import { type RowData } from '@tanstack/react-table';
import { type LegacyColumn as Column } from '@tanstack/react-table/legacy';
import DebouncedInput from './DebouncedInput';

export function RangeFilter<T extends RowData>({ column }: { column: Column<T> }) {
  const columnFilterValue = column.getFilterValue();

  return (
    <div>
      <DebouncedInput
        type="number"
        value={(columnFilterValue as [number, number] | undefined)?.[0] ?? ''}
        onChange={(value) => {
          column.setFilterValue((old: [number, number] | undefined) => [value, old?.[1]]);
        }}
        placeholder={`Min`}
      />
      <DebouncedInput
        type="number"
        value={(columnFilterValue as [number, number] | undefined)?.[1] ?? ''}
        onChange={(value) => {
          column.setFilterValue((old: [number, number] | undefined) => [old?.[0], value]);
        }}
        placeholder={`Max`}
      />
    </div>
  );
}

export function SearchFilter<T extends RowData>({ column }: { column: Column<T> }) {
  const columnFilterValue = column.getFilterValue();

  return (
    <DebouncedInput
      onChange={(value) => {
        column.setFilterValue(value);
      }}
      placeholder={`Search...`}
      type="text"
      value={(columnFilterValue ?? '') as string}
    />
  );
}
